import axios from "axios";

// import apiLockService from './lock'
import router from "@/router";
import utils from "@/utils";

const BASE_URL = process.env.VUE_APP_API_URL;
export const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 40000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

// console.log(process.env.VUE_APP_API_URL);
instance.interceptors.request.use(config => {
  const accessToken = utils.getToken();
  if (accessToken) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  // console.log('Intercepted config: ', config)
  return config;
});

instance.interceptors.response.use(
  response => response,
  async error => {
    window.apiError = error;
    const config = error.config;

    if (error.response) {
      window.responseError = error.response; // for debuging
      if (error.response.status === 401) {
        // Check if refresh token exists
        if (!utils.getRefreshToken()) {
          return Promise.reject(error);
        }
        // Try to refresh the token
        console.log("Refreshing token...");
        const response = await axios.post(BASE_URL + "/users/token/", {
          token: utils.getRefreshToken()
        });

        if (response.status === 401) {
          // Refresh token expired
          console.log("Token refresh failed: ", error);
          const currentRoute = router.history.current;

          // If I'm already in the login page dont bother
          if (currentRoute.name === "Login") return Promise.reject(error);

          router.push(utils.buildLoginRedirect());
        }

        // Token refreshed successfully
        // console.log(`Response for ${config.url}: `, response)
        // Set token
        const token = response.data.data;
        utils.setToken(token);

        // Retry last request
        try {
          const headers = config.headers;
          const c = {
            ...config,
            headers: {
              ...headers,
              Authorization: "Bearer " + token.accessToken
            }
          };

          const rs = await axios(c);
          // console.log('Success: ', config.url, config)
          return Promise.resolve(rs);
        } catch (error) {
          // console.log('Failed: ', config.url)
          return Promise.reject(error);
        }
      }
    }

    // other errors
    return Promise.reject(error);
  }
);

const api = {
  request(method, url, data, successMsg = null, errorMsg = null) {
    instance
      .request({
        url,
        data,
        method: method.toLowerCase()
      })
      .then(successMsg)
      .catch(errorMsg);
  },

  get(url, success = null, errorMsg = null) {
    return this.request("get", url, {}, success, errorMsg);
  },

  post(url, data, success = null, errorMsg = null) {
    return this.request("post", url, data, success, errorMsg);
  },

  put(url, data, success = null, errorMsg = null) {
    return this.request("put", url, data, success, errorMsg);
  },

  patch(url, data, success = null, errorMsg = null) {
    return this.request("patch", url, data, success, errorMsg);
  },

  delete(url, data = {}, success = null, errorMsg = null) {
    return this.request("delete", url, data, success, errorMsg);
  }
};

window.api = api;
export default api;
